import React from 'react';
import './Article.css';

const Article = () => {
  return (
    <div className="article-page">
      <h1>Articles</h1>
      
      <ul className="article-list">
        <li>
          <a href="https://clickmandu.com/2022/03/188503.html" target="_blank" rel="noopener noreferrer">
            अब एकै ठाउँबाट बीमा सम्बन्धी परामर्श पाइने
          </a>
        </li>
        <li>
          <a href="https://insurancekhabar.com/2022/05/142098/#.YnclxZoNWYc.viber" target="_blank" rel="noopener noreferrer">
            सरकारले जनप्रतिनिधिहरुको अनिवार्य बीमा गर्नु पर्छ, बीमा विज्ञ विके श्रेष्ठको नयाँ बजेटका लागि सुझाव
          </a>
        </li>
        <li>
          <a href="https://insurancekhabar.com/%e0%a4%aa%e0%a5%8d%e0%a4%b0%e0%a4%aa%e0%a4%b0-%e0%a4%87%e0%a4%a8%e0%a5%8d%e0%a4%b8%e0%a5%8d%e0%a4%af%e0%a5%8b%e0%a4%b0%e0%a5%87%e0%a4%a8%e0%a5%8d%e0%a4%b8%e0%a4%95%e0%a4%be-%e0%a4%b2%e0%a4%be%e0%a4%97/" target="_blank" rel="noopener noreferrer">
            प्रपर इन्स्योरेन्सका लागि ‘इन्स्योरेन्स कन्सल्टेन्सी’, बीमा गर्नेदेखि दाबी भुक्तानीसम्मको परामर्श सेवा
          </a>
        </li>
        <li>
          <a href="https://insurancekhabar.com/%e0%a4%aa%e0%a5%8d%e0%a4%b0%e0%a4%aa%e0%a4%b0-%e0%a4%87%e0%a4%a8%e0%a5%8d%e0%a4%b8%e0%a5%8d%e0%a4%af%e0%a5%8b%e0%a4%b0%e0%a5%87%e0%a4%a8%e0%a5%8d%e0%a4%b8%e0%a4%95%e0%a4%be-%e0%a4%b2%e0%a4%be%e0%a4%97/" target="_blank" rel="noopener noreferrer">
            प्रपर इन्स्योरेन्सका लागि ‘इन्स्योरेन्स कन्सल्टेन्सी’, बीमा गर्नेदेखि दाबी भुक्तानीसम्मको परामर्श सेवा
          </a>
        </li>
        <li>
          <a href="https://www.beemapost.com/2022/03/32423/" target="_blank" rel="noopener noreferrer">
            बीमा सम्बन्धी परामर्श दिन इन्स्योरेन्स कन्सल्टेन्सी नेपालको स्थापना
          </a>
        </li>
        <li>
          <a href="https://insurancekhabar.com/%e0%a4%a8%e0%a4%bf%e0%a4%b0%e0%a5%8d%e0%a4%9c%e0%a5%80%e0%a4%b5%e0%a4%a8-%e0%a4%ac%e0%a5%80%e0%a4%ae%e0%a4%be-%e0%a4%b5%e0%a5%8d%e0%a4%af%e0%a4%b5%e0%a4%b8%e0%a4%be%e0%a4%af%e0%a4%ae%e0%a4%be-2/" target="_blank" rel="noopener noreferrer">
            निर्जीवन बीमा व्यवसायमा जोखिम व्यवस्थापन, विके श्रेष्ठको लेख
          </a>
        </li>
      </ul>
      <p className="article-intro">
        Welcome to our Articles page. Here you will find the latest news and insights about insurance.
      </p>
    </div>
    
  );
};

export default Article;